var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { addHeaderToAPI } from "./apiServices/salesRepDataService";
import { getLoggedInRepDetails } from "./apiServices/salesRepDataService";
var shopName = getLoggedInRepDetails().shopName;
export function apiCallService(url, data, methodType, ctType, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var responseData, _a, ex_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    responseData = void 0;
                    if (!(methodType === "GET")) return [3 /*break*/, 3];
                    return [4 /*yield*/, getService(url, signal).then(function (data) { return data; })];
                case 1:
                    responseData = _b.sent();
                    if (url === null || url === void 0 ? void 0 : url.includes("data=28")) {
                        return [2 /*return*/, responseData.data];
                    }
                    return [4 /*yield*/, decryptData(responseData.data)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3: return [4 /*yield*/, postService(url, data, ctType).then(function (data) { return data; })];
                case 4:
                    responseData = _b.sent();
                    // Edit draft order (pageIndex=44): treat 200 as success even when data is false/minimal (server may return 200 with empty body)
                    if ((responseData === null || responseData === void 0 ? void 0 : responseData.status) === 200 && (url === null || url === void 0 ? void 0 : url.includes("pageIndex=44"))) {
                        return [2 /*return*/, responseData];
                    }
                    if (!(responseData.data != false && responseData.status === 200)) return [3 /*break*/, 6];
                    if ((url === null || url === void 0 ? void 0 : url.includes("pageIndex=44")) || (url === null || url === void 0 ? void 0 : url.includes("pageIndex=02")) || (url === null || url === void 0 ? void 0 : url.includes("pageIndex=14")) || (url === null || url === void 0 ? void 0 : url.includes("pageIndex=52"))) {
                        return [2 /*return*/, responseData];
                    }
                    _a = responseData;
                    return [4 /*yield*/, decryptData(responseData.data)];
                case 5:
                    _a.data = _b.sent();
                    if ((url === null || url === void 0 ? void 0 : url.includes("pageIndex=0")) || (url === null || url === void 0 ? void 0 : url.includes("pageIndex=31")) || (url === null || url === void 0 ? void 0 : url.includes("pageIndex=30"))) {
                        return [2 /*return*/, responseData];
                    }
                    _b.label = 6;
                case 6: return [2 /*return*/, responseData.data];
                case 7: return [3 /*break*/, 9];
                case 8:
                    ex_1 = _b.sent();
                    if (isAxiosAbortError(ex_1)) {
                        throw ex_1;
                    }
                    return [2 /*return*/, null];
                case 9: return [2 /*return*/];
            }
        });
    });
}
function isAxiosAbortError(error) {
    if (!error || typeof error !== "object") {
        return false;
    }
    var err = error;
    return err.code === "ERR_CANCELED" || err.name === "AbortError" || err.name === "CanceledError";
}
export function getService(url, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, axios({
                    method: "GET",
                    url: url,
                    headers: addHeaderToAPI(),
                })
                    .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, response];
                    });
                }); })
                    .catch(function (error) {
                    if (isAxiosAbortError(error)) {
                        throw error;
                    }
                    return error.response;
                })];
        });
    });
}
export function postService(url, data, ctType) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios({
                        method: "POST",
                        url: url,
                        headers: addHeaderToAPI(),
                        params: { shop: shopName },
                        data: data ? (ctType ? data : JSON.stringify(data)) : "",
                    })
                        .then(function (response) {
                        return responseHandling(response);
                    })
                        .catch(function (error) {
                        return error.response;
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function responseHandling(response) {
    if (typeof (response === null || response === void 0 ? void 0 : response.data) != "string" && (response === null || response === void 0 ? void 0 : response.data) === null && (response === null || response === void 0 ? void 0 : response.data) === "") {
        response.data = false;
    }
    return response;
}
export function encryptData(inputData) {
    return __awaiter(this, void 0, void 0, function () {
        var key, data1, encoder, dataIn, importedKey, iv, encryptedData, combinedData, dataArray, base64String, encodedData, ex_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    key = "nuH2aoKmHFHl8pNCzAOfbPoEx5JFTZPZ";
                    data1 = JSON.stringify(inputData);
                    encoder = new TextEncoder();
                    dataIn = encoder.encode(data1);
                    return [4 /*yield*/, crypto.subtle.importKey("raw", encoder.encode(key), "AES-CBC", false, ["encrypt"])];
                case 1:
                    importedKey = _a.sent();
                    iv = crypto.getRandomValues(new Uint8Array(16));
                    return [4 /*yield*/, crypto.subtle.encrypt({ name: "AES-CBC", iv: iv }, importedKey, dataIn)];
                case 2:
                    encryptedData = _a.sent();
                    combinedData = new Uint8Array((iv === null || iv === void 0 ? void 0 : iv.length) + encryptedData.byteLength);
                    combinedData.set(iv);
                    combinedData.set(new Uint8Array(encryptedData), iv === null || iv === void 0 ? void 0 : iv.length);
                    dataArray = Array.from(combinedData);
                    base64String = btoa(String.fromCharCode.apply(null, dataArray));
                    encodedData = base64String !== null ? btoa(base64String) : null;
                    return [2 /*return*/, encodedData];
                case 3:
                    ex_2 = _a.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function decryptData(encodedData) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var key, dataArray, combinedData, iv, encryptedData, importedKey, decryptedData, decoder, decryptedString, parsedData, ex_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    key = "nuH2aoKmHFHl8pNCzAOfbPoEx5JFTZPZ";
                    dataArray = (_a = Array.from(atob(encodedData))) === null || _a === void 0 ? void 0 : _a.map(function (char) { return char.charCodeAt(0); });
                    combinedData = new Uint8Array(dataArray);
                    iv = combinedData.slice(0, 16);
                    encryptedData = combinedData.slice(16);
                    return [4 /*yield*/, crypto.subtle.importKey("raw", new TextEncoder().encode(key), "AES-CBC", false, ["decrypt"])];
                case 1:
                    importedKey = _b.sent();
                    return [4 /*yield*/, crypto.subtle.decrypt({ name: "AES-CBC", iv: iv }, importedKey, encryptedData)];
                case 2:
                    decryptedData = _b.sent();
                    decoder = new TextDecoder();
                    decryptedString = decoder.decode(decryptedData);
                    parsedData = JSON.parse(decryptedString);
                    return [2 /*return*/, parsedData];
                case 3:
                    ex_3 = _b.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
